module.exports = __webpack_public_path__ + "static/media/Gilroy-Heavy-Italic.117fa97f.eot";